import * as React from "react";
import {AddressModalBase} from "../../../../../../../address-modal-base/address-modal-base";

/**
 * Before (pre) creation
 */
export const AddressModalP = ({next}) => (
    AddressModalBase({
        fields: [
            {
                path: "firstname",
                label: "First/Full Name",
                required: true,
            },
            {
                path: "lastname",
                label: "Last Name",
            },
            {
                path: "company",
                label: "Company",
            },
            {
                path: "houseNum",
                label: "House #",
            },
            {
                path: "street",
                label: "Address",
                required: true,
            },
            {
                path: "aptNum",
                label: "Apt #",
            },
        ],
        next,
    })
);
